var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import analysisTemplateActionTypes from "./AnalysisTemplateConstants.js";
import { AsyncRequestStatus, getDefaultAsyncWrapperObj, getCompletedAsyncWrapperObj } from "@ane/core/lib/models";
const getDefaultState = () => {
  return {
    routeContext: { templateName: null, editMode: null },
    templateAbstracts: { isLoading: false, data: null, error: null },
    analysisTemplate: { isLoading: false, data: null, error: null },
    editorTheme: "dark",
    templateSave: { status: AsyncRequestStatus.NotStarted, data: null, error: null },
    templateEditContent: null,
    userContext: { filter: null, showTemplatesWithType: null, debug_useFakeData: false, MS: null },
    registerDataSourceAsync: getDefaultAsyncWrapperObj()
  };
};
const AnalysisTemplateReducer = (state = getDefaultState(), actionResult) => {
  switch (actionResult.type) {
    case analysisTemplateActionTypes.SET_ROUTE_CONTEXT:
      return __spreadProps(__spreadValues({}, state), { routeContext: actionResult.payload });
    case analysisTemplateActionTypes.SET_USER_CONTEXT:
      return __spreadProps(__spreadValues({}, state), {
        userContext: actionResult.payload
      });
    case analysisTemplateActionTypes.SET_PARTIAL_USER_CONTEXT:
      return __spreadProps(__spreadValues({}, state), {
        userContext: __spreadValues(__spreadValues({}, state.userContext), actionResult.payload)
      });
    case analysisTemplateActionTypes.LOADING_TEMPLATE_ABSTRACTS:
      return __spreadProps(__spreadValues({}, state), { templateAbstracts: { isLoading: true, data: null, error: null } });
    case analysisTemplateActionTypes.LOADED_TEMPLATE_ABSTRACTS:
      return __spreadProps(__spreadValues({}, state), { templateAbstracts: { isLoading: false, data: actionResult.payload, error: null } });
    case analysisTemplateActionTypes.LOADING_TEMPLATE:
      return __spreadProps(__spreadValues({}, state), { analysisTemplate: { isLoading: true, data: null, error: null } });
    case analysisTemplateActionTypes.LOADED_TEMPLATE:
      return __spreadProps(__spreadValues({}, state), { analysisTemplate: { isLoading: false, data: actionResult.payload, error: null } });
    case analysisTemplateActionTypes.SET_TEMPLATE_EDIT_CONTENT:
      return __spreadProps(__spreadValues({}, state), { templateEditContent: actionResult.payload });
    case analysisTemplateActionTypes.SAVING_TEMPLATE:
      return __spreadProps(__spreadValues({}, state), { templateSave: { status: AsyncRequestStatus.Pending, data: null, error: null } });
    case analysisTemplateActionTypes.SAVED_TEMPLATE:
      return __spreadProps(__spreadValues({}, state), {
        templateSave: getCompletedAsyncWrapperObj("", actionResult.payload)
      });
    case analysisTemplateActionTypes.CREATING_TEMPLATE:
      return __spreadProps(__spreadValues({}, state), { templateSave: { status: AsyncRequestStatus.Pending, data: null, error: null } });
    case analysisTemplateActionTypes.CREATED_TEMPLATE:
      return __spreadProps(__spreadValues({}, state), {
        templateSave: getCompletedAsyncWrapperObj("", actionResult.payload)
      });
    case analysisTemplateActionTypes.TOGGLE_EDITOR_THEME:
      return __spreadProps(__spreadValues({}, state), { editorTheme: state.editorTheme === "dark" ? "light" : "dark" });
    case analysisTemplateActionTypes.REGISTERING_DATA_SOURCE:
      return __spreadProps(__spreadValues({}, state), {
        registerDataSourceAsync: __spreadProps(__spreadValues({}, state.registerDataSourceAsync), {
          status: AsyncRequestStatus.Pending
        })
      });
    case analysisTemplateActionTypes.REGISTERED_DATA_SOURCE:
      return __spreadProps(__spreadValues({}, state), {
        registerDataSourceAsync: __spreadValues(__spreadValues({}, state.registerDataSourceAsync), getCompletedAsyncWrapperObj(actionResult.payload.data, actionResult.payload.error))
      });
    default:
      return state;
  }
};
export {
  AnalysisTemplateReducer,
  AnalysisTemplateReducer as default,
  getDefaultState
};
//# sourceMappingURL=AnalysisTemplateReducer.js.map
